import { CATEGORY_FACET_ID } from "../constants";

const path = window.location.pathname.split("/")[1];
const id = window.location.pathname.split("/")[2];

const bringFilterData = ({ params }) => {
  return $.get(`/${path}/${id}.json`, params);
};

const bringResultsData = ({ params }) => {
  return $.get(`/${path}/${id}`, params);
};

const bringCompleteListOfFilters = ({ dataFromServer, categoryFilterId }) => {
  const facetParams = {};
  facetParams[CATEGORY_FACET_ID] = categoryFilterId;

  const params = {
    facets: facetParams,
    react_ajax_request: true,
    term: dataFromServer.term,
  };

  return $.get(`/${path}/${id}.json`, params);
};

const bringCountData = ({ dataFromServer, categoryFilterId }) => {
  const facetParams = Object.assign({}, dataFromServer.facet_params);
  facetParams[CATEGORY_FACET_ID] = categoryFilterId;

  const params = {
    facets: facetParams,
    price: {
      min: dataFromServer.min_price,
      max: dataFromServer.max_price,
    },
    react_ajax_request: true,
    term: dataFromServer.term,
  };

  return $.get(`/${path}/${id}.json`, params);
};

const api = {
  bringFilterData,
  bringResultsData,
  bringCompleteListOfFilters,
  bringCountData,
};
export default api;
